<template>
	<ui-root :part="{ type: 'interface'}" :data="{}" :errs="errors">
	<div class="scroll-frame">
		<div class="scroll-frame-head">
			<div class="head-title">
				<div class="fd-flow">
					<sym-icon name="pencil-bold" />
					<span class="fd-text">{{msg("join.title")}}</span>
				</div>
				<div v-if="errors && errors.length>0">
					<api-error level="SEVERE" :message="errorMessage"></api-error>
				</div>
			</div>
		</div>	
		<div class="scroll-frame-body">
			<div v-if="loaded">
				<table class="agenda">
				<thead>
					<tr>
						<th><span class="fd-text">{{msg("form.title.change")}}</span></th>
						<th><span class="fd-text">{{msg("prefs.pdata")}}</span></th>
					</tr>
				</thead>
				<tbody>
					<template v-for="(field, index) in bulkChanges.fields" :key="field.definition.property">
						<bulk-change-item :data="field" v-model="dataResult" :index="index" />
					</template>
				<tr><td colspan="2"><span v-html="msg('giveToUser.warning')" style='font-style: italic;'></span></td></tr>
				</tbody>
				</table>
			</div>
		</div>
		<div class="scroll-frame-tail">	
			<div class="tablepager">
				<div class="tablepager-content">
					<span class="pagercontrols"></span>
					<span class="tablesetting" >
						<button type="button" class="fd-button" :disabled="!canUseSaveButt" @click="resolveChanges">{{msg("butt.join")}}</button>
					</span>
				</div>
			</div>
		</div>
	</div>
	</ui-root>
</template>

<script setup lang="ts">

import {onMounted, ref, reactive, computed, provide} from "vue";
import {injectEnv} from "@fd/Environment";
import type {ErrorMap} from "@fd/PartInjectKeys";
import {useRouter,useRoute} from "vue-router";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import type {BulkChanges} from "@t/agenda/Consolidator.ts";
import {msg} from "@/i18n/Message";
import SymIcon from "@fd/helpers/SymIcon.vue";
import BulkChangeItem from "@/vue/agenda/BulkChangeItem.vue";
import ApiError from "@/fd/helpers/ApiError.vue";
import UiRoot from "@fd/containers/UiRoot.vue";


const props = defineProps<{
	urlPart: string,
	agendaName: string
}>();

const env = injectEnv();
const navStore = useNavigationStore();
const router = useRouter();
const route = useRoute();

const loaded = ref<boolean>(false);
const saving = ref<boolean>(false);
const errors = reactive<ErrorMap>([]);
const bulkChanges = ref<BulkChanges|null>(null);
const dataResult = ref({ checkBoxes : {} });

const canUseSaveButt = computed(() => {
	return saving.value===false && checkedFields.value.length > 0;
});

const errorMessage = computed(() => {
	let erfMes = msg('err.formContainsError');
	if (errors.length>0) {
		erfMes = erfMes+" "+errors[0].message;
	}
	return erfMes;
});

const checkedFields = computed(() => {
	return Object.keys(dataResult.value.checkBoxes).filter(key => dataResult.value.checkBoxes[key] === true);
});

const checkedDataResult = computed(() => {
	var result = {};
	checkedFields.value.forEach((key) => {
		let value = dataResult.value[key];
		if (value === undefined) {
			value = null;
		}
		result[key] = value;
	});
	return result;
});

function loadData() {
	let endpoint = "api/"+props.urlPart+"/bulkchanges";
	if (props.agendaName) endpoint = env.net.urlParam(endpoint, "agendaName", props.agendaName);
	return env.net.fetch(endpoint)
			.then((result) => result.json())
			.then(receivedData);
}

function receivedData(data):void {
	bulkChanges.value = data.bulkChanges;
	loaded.value = true;
}

function resolveChanges(): void {
	//console.log("sending dataResult:"+JSON.stringify(checkedDataResult.value));
	let endpoint = "api/"+props.urlPart+"/bulkchanges";
	if (props.agendaName) endpoint = env.net.urlParam(endpoint, "agendaName", props.agendaName);
	
	try {
		document.body.style.cursor = "progress";
		saving.value = true;
		errors.length = 0;
		env.net.fetch(endpoint, "POST", checkedDataResult.value)
			.then((response) => {
				if (response.ok) { //errors will be shown at agenda next step
					router.back();
				} else {
					response.json()
						.then((data) => {
							if (Array.isArray(data.problems)) {
								for (let problem of data.problems) {
									console.log("problem:"+JSON.stringify(problem));
									errors.push(problem);
								}
							}		
					});
				}
			});
	} finally {
		saving.value = false;
		document.body.style.cursor = "auto";
	}
}

onMounted(() => {
	navStore.setStandardMenu();
	navStore.forward(env.msg("join.title"));
	loadData();
});
</script>

<style>

</style>